import { ServerClient } from 'common/utils/http/http-clients';
import { IRejectRentalAgencyChange, IRentalAgencyChangeDetailsRead, IRentalAgencyChangeRead } from './rental-agency-change.service.types';

class RentalAgencyChangeService {
  async getRentalAgencyChanges(): Promise<IRentalAgencyChangeRead[]> {
    const res = await ServerClient.get<IRentalAgencyChangeRead[]>('/rental-agency-changes');
    return res?.data;
  }

  async getRentalAgencyChange(agencyChangeId: number): Promise<IRentalAgencyChangeDetailsRead> {
    const res = await ServerClient.get<IRentalAgencyChangeDetailsRead>(`/rental-agency-changes/${agencyChangeId}`);
    return res?.data;
  }

  async approve(agencyChangeId: number): Promise<void> {
    await ServerClient.post(`/rental-agency-changes/${agencyChangeId}/actions/approve`);
  }

  async reject(agencyChangeId: number, model: IRejectRentalAgencyChange): Promise<void> {
    await ServerClient.post(`/rental-agency-changes/${agencyChangeId}/actions/reject`, model);
  }
}

export const rentalAgencyChangeService = new RentalAgencyChangeService();
export default rentalAgencyChangeService;
